module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.programs), function(option, index) {
    return _c('label', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isValueHidden(option.label)),
        expression: "!isValueHidden(option.label)"
      }],
      staticClass: "mt-checkbox mt-checkbox-outline",
      class: {
        'disabled': option.status === 0
      }
    }, [_vm._v(_vm._s(option.name) + "\n    "), _c('input', {
      attrs: {
        "name": _vm.field.name + '-' + index,
        "type": "checkbox",
        "id": option.name,
        "disabled": _vm.locked || option.status === 0
      },
      domProps: {
        "value": option.id,
        "checked": _vm.value.includes(option.id.toString())
      },
      on: {
        "change": function($event) {
          _vm.toggleValue(option.id.toString())
        }
      }
    }), _vm._v(" "), _c('span')])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b54ea2b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/formbuilder/render/ProgramCheckboxRender.vue
// module id = 1650
// module chunks = 1